require('../../../packages/lav-galaxy/framework/resources/js/habitats/website.js')

import AutoloadViews from '@galaxy/js/common/AutoloadViews';

// @ugly, could not move to ^ since we could not guess the path to this habitat. Might by from /demo or of the clients project.
AutoloadViews.load('common.canvas', require.context('./../../components/common/canvas/', true, /\/block.(js|vue)$/));
AutoloadViews.load('habitats.website', require.context('./website/', true, /.(js|vue)$/));
AutoloadViews.load('components.habitats.website', require.context('./../../components/habitats/website/', true, /.(js|vue)$/));